import './songList.css'
import {Link} from 'react-router-dom'
import { Options } from '../../components'
import { UserContext } from '../../../Routes/Routes1'
import { useContext } from 'react'
import axios from 'axios'

function songs(song,path,key,isLogin){
    function lastPlayingSong(currentPlayingSong){
        if(isLogin){
            const USER_STORAGE=JSON.parse(localStorage.getItem("sangeetUser"))
            USER_STORAGE.lastPlayingSong.sType=currentPlayingSong.sType
            USER_STORAGE.lastPlayingSong.sName=currentPlayingSong.sName
            USER_STORAGE.lastPlayingSong.song=currentPlayingSong.song
            USER_STORAGE.lastPlayingSong.sImage=currentPlayingSong.sImage
            USER_STORAGE.lastPlayingSong.maName=currentPlayingSong.maName
            USER_STORAGE.lastPlayingSong.sDuration=currentPlayingSong.sDuration
            localStorage["sangeetUser"]=JSON.stringify(USER_STORAGE)
            const newData=JSON.parse(localStorage.getItem("sangeetUser"))
        
            axios.post(`https://${process.env.REACT_APP_URL_PORT}/admin/update_user`,newData)
        }
    }

    return(
        <div className="col-md-6 col-12 mbscl" key={key}>
            <div className='row '>
                <div className="col-3"> 
                    <Link to={`/${song.sType}/${song._id}`} onClick={()=>lastPlayingSong(song,isLogin)}>
                        <img className=' img-fluid' src={song.sImage}  alt="song-img"/>
                    </Link>
                </div> 
                
                <div className="col-6 mt-2">
                    <Link id="mtx" to={`/${song.sType}/${song._id}`} onClick={()=>lastPlayingSong(song,isLogin)}>
                        {song.sName}
                        {/* <div style={{fontSize:'small'}}>{song.maName}</div> */}
                    </Link>
                </div>
                <div className='col-3'>
                    <Options songData={song}/>
                </div>
            </div>
        </div>
      
    )
}


export default  function SongList({path,songsData}){
    const {state}=useContext(UserContext)
   
    return (
        <div className='row container-fluid'>
            {
                songsData.map((val,index)=>songs(val,path,index,state)) 
            }
        </div >
    )
}